var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 17.5V20H5V17.5C5 17.2239 4.77614 17 4.5 17H3.5C3.22386 17 3 17.2239 3 17.5V21C3 21.5523 3.44772 22 4 22L20 22C20.5523 22 21 21.5523 21 21V17.5C21 17.2239 20.7761 17 20.5 17H19.5C19.2239 17 19 17.2239 19 17.5ZM11 13.5858V3C11 2.44772 11.4477 2 12 2C12.5523 2 13 2.44772 13 3L13 13.5858L15.7929 10.7929C16.1834 10.4024 16.8166 10.4024 17.2071 10.7929C17.5976 11.1834 17.5976 11.8166 17.2071 12.2071L12.7071 16.7071C12.3166 17.0976 11.6834 17.0976 11.2929 16.7071L6.79289 12.2071C6.40237 11.8166 6.40237 11.1834 6.79289 10.7929C7.18342 10.4024 7.81658 10.4024 8.20711 10.7929L11 13.5858Z",
    fill: "#5C5C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.762b6656a4c9db998eb2e6d43a1e593a.svg";
export { ForwardRef as ReactComponent };